import { andriodAdapt } from '../utils';

const {
  screenHeight,
  statusBarHeight,
  screenWidth,
  safeAreaInsets,
  softMenuBarHeight = 0,
  isAndroid,
  isIOS,
  navigationBarHeight
} = Mach.env;
const isLowAndroid = andriodAdapt();
let adaptStatusHeight = 0;
// statusBarHeight为0
if (isLowAndroid && !statusBarHeight) {
  adaptStatusHeight = 24;
}

const { bottom = 0 } = safeAreaInsets || {};
const btnBottom = bottom > 0 ? bottom : 16;
const SEARCH_INPUT_HEIGHT = 56;
const ASSOCIATE_CONTAINER_HEIGHT = 286 + btnBottom + (Mach.env?.isAndroid ? 5 : 0);
const CLOSE_BTN_TOP = statusBarHeight + 4;
const addEmptyHeight = 52 + 4 + 8; // 关闭按钮以及空白区域占的最小高度
const addContentHeight = screenHeight - statusBarHeight - addEmptyHeight - softMenuBarHeight - adaptStatusHeight;
const addBaseHeight = 686 + btnBottom; // 能填充完内容的高度
const ADD_ADDRESS_CONTAINER_HEIGHT = addContentHeight > addBaseHeight ? addBaseHeight : addContentHeight;
const SEATCH_HEADER_HEIGHT = SEARCH_INPUT_HEIGHT + navigationBarHeight + statusBarHeight;
const MAP_HEIGHT = screenHeight - ASSOCIATE_CONTAINER_HEIGHT - softMenuBarHeight + 4 - SEATCH_HEADER_HEIGHT;
// IOS 地图中心点位置：地图View高度-状态栏高度
// const REAL_MAP_HEIGHT = isIOS ? MAP_HEIGHT - statusBarHeight : MAP_HEIGHT;
const REAL_MAP_HEIGHT = MAP_HEIGHT;
export const LOC_ICON_WIDTH = 60;
export const LOC_ICON_HEIGHT = 60;
// const LOC_ICON_TOP = isIOS
//  ? REAL_MAP_HEIGHT / 2 + statusBarHeight - LOC_ICON_HEIGHT + 2
//  : REAL_MAP_HEIGHT / 2 - LOC_ICON_HEIGHT + 2;
export const LOC_ICON_TOP = REAL_MAP_HEIGHT / 2 - LOC_ICON_HEIGHT + 8 + SEATCH_HEADER_HEIGHT;
export const LOC_ICON_LEFT = screenWidth / 2 - LOC_ICON_WIDTH / 2;
const FOCUS_BTN_BOTTOM = ASSOCIATE_CONTAINER_HEIGHT + 12;
const addContentHeightV2 = screenHeight - softMenuBarHeight;
const topContainerHeight = 44 + CLOSE_BTN_TOP;
const editMainTitleTopMargin = 24;
const editMainTitleLeftMargin = 3;
const permissionTipHeight = 40; // 权限条高度
enum OpType {
  add = 'add', // 新增地址
  edit = 'edit', // 编辑地址
  map = 'map', // 地图选点
}
enum ADDRESS_SOURCE {
  associate = 1,
  search = 2,
  poi = 3,
}
enum SCENES {
  home = 0,
  mine = 1,
  preview = 2,
  register = 3,
  guidance = 4,
  changeAddress = 6, // 下单后修改地址场景
  homeAdd = 11, // 首页新增地址场景
}
const LOC_RECT = {
  width: LOC_ICON_WIDTH,
  height: LOC_ICON_HEIGHT,
  top: LOC_ICON_TOP,
  left: LOC_ICON_LEFT,
};
const LOC_NAME_BOTTOM = screenHeight - softMenuBarHeight - LOC_ICON_TOP;

export enum PhotosType {
  /** 历史数据未标注类型的图片 */
  unknown = 0,
  /** 楼栋外观、建筑物相关照片 */
  building = 1,
  /** 单元门等照片 */
  door = 2,
  /** 明确为其他类型的照片（但不是 building/door） */
  other = 3,
}

/**
 * 开放地图吸附绿点来源类型
 */
export enum LocatePointType {
  /** 接口返回后自动吸附 */
  autoAdsorb = 1,
  /** 用户点击绿点手动切换 */
  manualSwitch = 2,
  /** 使用自由扎点（freePoint） */
  freePoint = 3,
}

/**
 * 首页定位类型
 * @enum {number}  0:默认地址（旺角） 1:nearby接口获取 2:地图选点 3:收货地址
 */
enum LOCATION_TYPE {
  defaultType = 0,
  nearBy = 1,
  map = 2,
  address = 3,
}

/**
 * LBS接口返回poiType
 * 0：关键字搜索POI结果（存在真实poiName） 1：逆地理编码POI（不存在真实poiName）
 * @enum {number}
 */
enum MAP_POI_TYPE {
  search = 0,
  nearBy = 1,
}

const DEFAULT_MAP_SOURCE = 'google';

const MAP_SOURCE = {
  google: 'google',
  here: 'here',
  // 地图交付点标识
  rec_poi: 'rec_poi',
  // 自研地图
  meituan: 'meituan',
};
// 文字的方向
const MARKER_TEXT_POSITION = {
  left: 'left',
  right: 'right'
};
const PIN_MARKER = {
  iconWidth: 20, // icon 宽度
  iconHeight: 20, // icon 高度
  blankWidth: 8, // 空白区域宽度
  maxTextWidth: 122, // 能展示的最长文字长度
  maxWidth: 151, // marker 最大长度
};
// 搜索后实验：控制搜索后返回编辑页还是地图拖点页
const SEARCH_EXP = {
  groupKey: 'address_pin_confirm_again_and_suggest_pin_exp1',
  jumpToEdit: '1', // 跳转到编辑页
  jumpToPoi: '2', // 跳转到地图选点页
};

const LX_FROM_SOURCE = {
  search: 1, // 搜索后进入地图拖点页
  other: 2, // 其他场景的地图拖点页
};
// 地图展示交付点的缩放比例：低于该比例不展示交付点
const SUGGEST_VISIBLE_ZOOM = 16;
const SUGGEST_INIT_ZOOM_LEVEL = 17;
const SUGGEST_INIT_ZOOM_LEVEL_SA = 8;
const MIN_ZOOM_LEVEL = 8; // Keeta限制到8
const MAX_ZOOM_LEVEL = 19; // 来自Google地图实测限制
const HK_STRUCT_TYPE = 0; // 0-HK结构化
const HK_FIELD_NAMES = ['street', 'streetNumber', 'buildingName', 'buildingNumber', 'unitNumber'] as const; // HK 输入信息
const SA_FIELD_NAMES = ['street', 'streetNumber', 'addressDetail'] as const; // SA 输入信息
const UNSTRUCT_TYPE = 1; // 1-非结构化
const REGION_NULL = 1;
const CORE_PARAM_FETCH_ERROR = 2;
const LOCATION_PARAMS = {
  onceLocationInterval: 1000, // 单次定位时间间隔
  compassSensorInterval: 100, // 陀螺仪传感器时间间隔
  compassSensorAngle: 3, // 陀螺仪传感器，角度阈值
};
const INPUT_USER_NAME_MAX_LENGTH = 30;
const SAVE_OR_UPDATE_NETWORK_ERROR_CODES = [
  403, -152, -172, -105, -309, -151, -306, -330, -102, -156, -106, -107, -199, -315
];
const MAP_POLYGON_ZOOM = 8; // keemart 围栏缩放比例

enum PrimaryButtonType {
  confirm = 1,
  save = 2,
  retry = 3
}

enum ClientType {
  im = 'im',
  C = 'c'
}

// 纠偏弹窗关闭类型
enum CorrectionDialogCloseType {
  close = 1,
  confirm = 2,
}
export {
  OpType,
  ASSOCIATE_CONTAINER_HEIGHT,
  REAL_MAP_HEIGHT,
  ADD_ADDRESS_CONTAINER_HEIGHT,
  MAP_HEIGHT,
  CLOSE_BTN_TOP,
  LOC_RECT,
  LOC_NAME_BOTTOM,
  ADDRESS_SOURCE,
  FOCUS_BTN_BOTTOM,
  isAndroid,
  isIOS,
  screenWidth,
  SCENES,
  LOCATION_TYPE,
  MAP_POI_TYPE,
  DEFAULT_MAP_SOURCE,
  addBaseHeight,
  bottom,
  addContentHeight,
  addContentHeightV2,
  topContainerHeight,
  isLowAndroid,
  SEATCH_HEADER_HEIGHT,
  SEARCH_INPUT_HEIGHT,
  btnBottom,
  MAP_SOURCE,
  MARKER_TEXT_POSITION,
  PIN_MARKER,
  SUGGEST_VISIBLE_ZOOM,
  MAP_POLYGON_ZOOM,
  SEARCH_EXP,
  LX_FROM_SOURCE,
  SUGGEST_INIT_ZOOM_LEVEL,
  HK_STRUCT_TYPE,
  UNSTRUCT_TYPE,
  REGION_NULL,
  CORE_PARAM_FETCH_ERROR,
  statusBarHeight,
  addEmptyHeight,
  LOCATION_PARAMS,
  MIN_ZOOM_LEVEL,
  MAX_ZOOM_LEVEL,
  INPUT_USER_NAME_MAX_LENGTH,
  SAVE_OR_UPDATE_NETWORK_ERROR_CODES,
  PrimaryButtonType,
  ClientType,
  SUGGEST_INIT_ZOOM_LEVEL_SA,
  editMainTitleTopMargin,
  editMainTitleLeftMargin,
  permissionTipHeight,
  CorrectionDialogCloseType,
  HK_FIELD_NAMES,
  SA_FIELD_NAMES
};
